import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { OperadorService } from '../services/operador.service';
import { IUsersystem } from '../interfaces/usersystem';
import { SearchService } from '../services/search.service';
import { Subscription } from 'rxjs';

import { faTv, faBars, faFilter } from '@fortawesome/free-solid-svg-icons';

import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
  public faTv = faTv;
  public faBars = faBars;
  public faFilter = faFilter;

  public operador: IUsersystem;

  public searchVisible: boolean = false;
  public placeholderSearch: string = '';

  public searchFilter: boolean = false;
  public indicatorScreen: boolean = false;

  public searchFrm: FormGroup;
  public searchField: FormControl;

  public pageName = '';

  public inTest: boolean = false;
  public isHidden: boolean = false;

  private subscription: Subscription;

  public url_estabelecimento: string = '';

  public openMenu: boolean = false;

  constructor(
    public router: Router,
    private _operadorService: OperadorService,
    private _searchService: SearchService
  ) {
    this.operador = this._operadorService.getOperador();

    if (this.operador.estabelecimento['periodo_teste'] != null) {
      this.inTest = true;

      if (this.operador.estabelecimento['periodo_teste']['over']) {
        this.isHidden = true;
      }
    }

    this.subscription = this._operadorService.url_estabelecimento.subscribe(
      (res) => {
        this.url_estabelecimento = res;
      }
    );

    this.createFormControls();
    this.createForm();

    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.searchVisible = false;
        this.searchFilter = false;
        this.placeholderSearch = '';
        this.searchField.setValue('');
        this.pageName = '';

        if (val.url.match(/\/app\/visao-geral/g)) {
          this.searchVisible = false;
          this.placeholderSearch = '';
          this.searchField.setValue('');

          this.pageName = 'dashboard';
        }

        if (val.url.match(/\/app\/pedidos/g)) {
          this.searchVisible = true;
          this.searchField.setValue('');
          this.placeholderSearch =
            screen.width > 480 ? 'Digite para buscar pedidos...' : 'Pedidos';
          this.searchFilter = true;

          this.pageName = 'order';
        }

        if (val.url.match(/\/app\/estoque/g)) {
          this.searchVisible = true;
          this.searchFilter = true;
          this.searchField.setValue('');
          this.placeholderSearch =
            screen.width > 480 ? 'Digite para buscar produtos...' : 'Produtos';

          this.pageName = 'product';
        }

        if (val.url.match(/\/app\/produto/g)) {
          this.searchVisible = false;
          this.placeholderSearch = '';
          this.searchField.setValue('');

          this.pageName = 'register-product';
        }

        if (val.url.match(/\/app\/descontos\/cupons/g)) {
          this.searchVisible = true;
          this.searchField.setValue('');
          this.placeholderSearch =
            screen.width > 480 ? 'Digite para buscar cupons...' : 'Cupons';

          this.pageName = 'coupon';
        }

        if (val.url.match(/\/app\/clientes/g)) {
          this.searchVisible = true;
          this.searchField.setValue('');
          this.placeholderSearch =
            screen.width > 480 ? 'Digite para buscar clientes...' : 'Clientes';

          this.pageName = 'customer';
        }

        if (val.url.match(/\/app\/descontos\/promocoes/g)) {
          this.searchVisible = true;
          this.searchField.setValue('');
          this.placeholderSearch =
            screen.width > 480
              ? 'Digite para buscar Promoções...'
              : 'Promoções';

          this.pageName = 'promotion';
        }

        if (val.url.match(/\/app\/cupom-desconto/g)) {
          this.searchVisible = false;
          this.placeholderSearch = '';
          this.searchField.setValue('');

          this.pageName = 'register-coupon';
        }
      }
    });
  }

  ngOnInit(): void {}

  toogleMenu() {
    this.openMenu = !this.openMenu;
  }

  closeMenu() {
    this.openMenu = false;
  }

  /**
   * Funcao que mostra/esconde tela de indicadores
   */
  openCloseIndicatorcreen() {
    this.indicatorScreen = !this.indicatorScreen;
  }

  clearField() {
    this.searchField.setValue('');
    this.search();
  }

  createFormControls() {
    this.searchField = new FormControl('');
  }

  createForm() {
    this.searchFrm = new FormGroup({
      searchField: this.searchField,
    });
  }

  search() {
    this._searchService.find(this.searchField.value, this.pageName);
  }

  openFilter(ev) {
    this._searchService.openFilter({ action: this.pageName, payload: ev });
  }

  onSubmitSearch() {
    return false;
  }

  logoff() {
    this._operadorService.authGuardOperadorOut();
    this.router.navigate(['acessar']);
  }
}
